import { render, staticRenderFns } from "./indexBlockTitle.vue?vue&type=template&id=75b30536"
import script from "./indexBlockTitle.vue?vue&type=script&lang=js"
export * from "./indexBlockTitle.vue?vue&type=script&lang=js"
import style0 from "./indexBlockTitle.vue?vue&type=style&index=0&id=75b30536&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports